import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { injectIntl } from 'react-intl'
import { sampleDataSelector } from '../../../../redux/selectors'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import SurveyResponseTabs from './SurveyResponseTabs'
import { Container, Grid } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	titleRoot: {
		color: 'white',
		fontWeight: '400',
		paddingTop: '2rem',
		textAlign: 'center',
	},
	textRoot: {
		color: 'white',
		fontWeight: '400',
		paddingTop: '2rem',
		textAlign: 'center',
		fontWeight: '400',
		marginTop: '10px',
		marginBottom: '20px'
	},
}))

const SurveyResponseSample = ({ intl, sampleData }) => {
	const classes = useStyles()
	return (
		<div>
			<Container data-testid="survey-response-sample" maxWidth="lg">
				<Grid container alignItems="center" justify="center" >
					<Grid item xs={12} sm={6}>
						<Typography data-testid="survey-response-sample-title" variant='h4' className={classes.titleRoot}>
							{intl.formatMessage({ id: 'app.dashboard.sampleResults' })}
						</Typography>

						<Typography
							data-testid="survey-response-sample-desc"
							className={classes.textRoot}
							variant='body1'
						>
							{intl.formatMessage({
								id: 'app.dashboard.sampleResultsDescription',
							})}
						</Typography>
					</Grid>
					<Grid item xs={12}>
						{sampleData && <SurveyResponseTabs data-testid="survey-response-sample-tabs" schema={sampleData}/>}
					</Grid>
				</Grid>
			</Container>
		</div>
	)
}

const mapStateToProps = (state, ownProps) => ({
	sampleData: sampleDataSelector(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({})

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(SurveyResponseSample)
